import { render, staticRenderFns } from "./EntrepreneurIntroInfo.vue?vue&type=template&id=2c99e6c0&scoped=true&"
import script from "./EntrepreneurIntroInfo.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurIntroInfo.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurIntroInfo.vue?vue&type=style&index=0&id=2c99e6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99e6c0",
  null
  
)

export default component.exports